export const LmsEnrollmentStatus = {
  NotEnrolled: 'NotEnrolled',
  InProgress: 'InProgress',
  Completed: 'Completed',
} as const;

export type LmsEnrollmentStatus = (typeof LmsEnrollmentStatus)[keyof typeof LmsEnrollmentStatus];

export const LmsQuizStatus = {
  NotStarted: 'NotStarted',
  InProgress: 'InProgress',
  Submitted: 'Submitted',
  Graded: 'Graded',
} as const;

export type LmsQuizStatus = (typeof LmsQuizStatus)[keyof typeof LmsQuizStatus];

export const LmsGradingType = {
  NUMERIC: 'NUMERIC',
  PERCENTAGE: 'PERCENTAGE',
  ALPHABET: 'ALPHABET',
  PASS_FAIL: 'PASS_FAIL',
  GPA_SCALE: 'GPA_SCALE',
} as const;

export type LmsGradingType = (typeof LmsGradingType)[keyof typeof LmsGradingType];

export const LmsAssignmentType = {
  QUIZ: 'QUIZ',
} as const;

export type LmsAssignmentType = (typeof LmsAssignmentType)[keyof typeof LmsAssignmentType];

const GRADING_VALUES = new Set<string>(Object.values(LmsGradingType));

export function parseLmsGradingType(value: unknown): LmsGradingType {
  if (typeof value === 'string' && GRADING_VALUES.has(value)) {
    return value as LmsGradingType;
  }

  return LmsGradingType.PERCENTAGE;
}
